export default __webpack_public_path__ + "static/media/top-pattern.6bac373f.png";